"use client"
import { motion } from "framer-motion"
import { Star, ChevronLeft, ChevronRight } from 'lucide-react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const testimonials = [
  {
    text: "Morbi nec accusant diam Maecenas gravida masa Admetus laces leafed, at rostrum talus condiment arco et vitae magna maximite meatus torpids pharetra.",
    author: "Lance Bagrol",
    avatar: "/images/team3.jpg",
    rating: 5,
  },
  {
    text: "Morbi nec accusant diam Maecenas gravida masa Admetus laces leafed, at rostrum talus condiment arco et vitae magna maximite meatus torpids pharetra.",
    author: "Hanson Dick",
    avatar: "/images/team2.jpg",
    rating: 5,
  },
  {
    text: "Morbi nec accusant diam Maecenas gravida masa Admetus laces leafed, at rostrum talus condiment arco et vitae magna maximite meatus torpids pharetra.",
    author: "Miles Tone",
    avatar: "/images/team.jpg",
    rating: 5,
  },
]

function NextArrow(props) {
  const { onClick } = props
  return (
    <button
      onClick={onClick}
      className="absolute -right-4 top-1/2 -translate-y-1/2 p-2 rounded-full border border-gray-200 bg-white hover:bg-gray-50 transition-colors"
      aria-label="Next slide"
    >
      <ChevronRight className="w-5 h-5" />
    </button>
  )
}

function PrevArrow(props) {
  const { onClick } = props
  return (
    <button
      onClick={onClick}
      className="absolute -left-4 top-1/2 -translate-y-1/2 p-2 rounded-full border border-gray-200 bg-white hover:bg-gray-50 transition-colors z-10"
      aria-label="Previous slide"
    >
      <ChevronLeft className="w-5 h-5" />
    </button>
  )
}

export function TestimonialsSection() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  }

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-blue-600 font-medium block mb-4"
          >
            Team Of Specialist
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold leading-none"
          >
            Don't just take our word for it
          </motion.h2>
        </div>

        <div className="px-4">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="p-4"
              >
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-600 mb-6 text-left">{testimonial.text}</p>
                  <div className="flex items-center gap-3">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.author}
                      className="rounded-full size-10"
                    />
                    <span className="font-semibold">— {testimonial.author}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </Slider>
        </div>

        <div className="text-center mt-12">
          <p className="text-lg">
            <span className="font-semibold">5.0</span> Out of <span className="font-semibold">5.0</span>{" "}
            Based On <a href="#home" className="underline font-semibold">1763 reviews</a>
          </p>
        </div>
      </div>
    </section>
  )
}

